import React from "react";
import { BookOpenIcon, SearchIcon, CheckCircle2Icon } from "lucide-react";
import { Section, Reveal, Eyebrow } from "./ui";
const steps = [{
  icon: BookOpenIcon,
  text: "Abrís el tomo correcto."
}, {
  icon: SearchIcon,
  text: "Leés la estrategia correcta."
}, {
  icon: CheckCircle2Icon,
  text: "Y sabés exactamente qué hacer."
}];
export function Presentation() {
  return <Section id="presentacion" className="bg-white" data-id="element-191" data-mp="25q47b9rthx8a">
      <Reveal className="text-center" data-id="element-192" data-mp="25rp0auyhh841">
        <Eyebrow data-id="element-193" data-mp="20rki90hxg5bp">El sistema</Eyebrow>
        <h2 className="mx-auto max-w-3xl font-serif-display text-3xl font-semibold leading-tight text-[var(--ink)] sm:text-4xl" data-id="element-194" data-mp="20qhrqtoio4wb">
          El sistema completo para acompañar a tu hijo paso a paso.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-[var(--muted)]" data-id="element-195" data-mp="1quo6mlwqf32x">
          En lugar de buscar respuestas diferentes todos los días…
        </p>
      </Reveal>

      <div className="mt-7 grid grid-cols-3 gap-2 sm:mt-12 sm:gap-5" data-id="element-196" data-mp="3l6mh0r6s250e">
        {steps.map((s, i) => <Reveal key={s.text} delay={i * 0.1} data-id="element-197" data-mp="2v0i1ppycjc9t" data-mpi={i}>
            <div className="flex h-full flex-col items-center rounded-2xl border border-[#e6eef5] bg-[var(--calm-blue)]/40 p-3 text-center sm:rounded-3xl sm:p-8" data-id="element-198" data-mp="2uzq5qe0u7cj0">
              <span className="mb-2 flex h-9 w-9 items-center justify-center rounded-xl bg-white text-[var(--accent)] shadow-sm sm:mb-4 sm:h-14 sm:w-14 sm:rounded-2xl" data-id="element-199" data-mp="2l3wx35q8o36i">
                <s.icon className="h-4 w-4 sm:h-6 sm:w-6" aria-hidden data-id="element-200" data-mp="3drsqo1kihez2" />
              </span>
              <span className="mb-1 text-[9px] font-bold text-[var(--accent)] sm:mb-3 sm:text-xs" data-id="element-201" data-mp="3iqm2zqo2azxn">
                Paso {i + 1}
              </span>
              <p className="font-serif-display text-xs leading-tight text-[var(--ink)] sm:text-lg" data-id="element-202" data-mp="340y40w3csdd3">{s.text}</p>
            </div>
          </Reveal>)}
      </div>
    </Section>;
}